import React, { useState } from 'react';

import { useDeleteContactsGroupContactMutation } from '@dashboard/generated/wp/platform';
import { RemoveCircleOutlineOutlined } from '@mui/icons-material';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';

import { alertSuccess } from '@waypoint/react/notifications';

import useCurrentContactsGroupContacts from './useCurrentContactsGroupContacts';

type Props = {
  emailAddress: string;
  id: string;
};

export default function DeleteContactsGroupContactButton({ id, emailAddress }: Props) {
  const [open, setOpen] = useState(false);
  const [deleteContact, { loading }] = useDeleteContactsGroupContactMutation();
  const { refetch } = useCurrentContactsGroupContacts();

  const onClick: React.MouseEventHandler = (ev) => {
    ev.preventDefault();
    ev.stopPropagation();
    setOpen(true);
  };

  const onClose: React.MouseEventHandler = () => {
    setOpen(false);
  };

  const onSubmit = async () => {
    await deleteContact({ variables: { id } });
    alertSuccess('Contact deleted');
    setOpen(false);
    await refetch();
  };

  return (
    <>
      <IconButton onClick={onClick}>
        <RemoveCircleOutlineOutlined />
      </IconButton>
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>Remove from unsubscribe group?</DialogTitle>
        <DialogContent>Are you sure you want to remove {emailAddress} from this group?</DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="secondary">
            Cancel
          </Button>
          <Button disabled={loading} variant="contained" color="error" onClick={onSubmit}>
            Yes, remove
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
